
const Logo = () => {
  return (
    <h2
      style={{
        color: "#2CB1BC",
        fontWeight: 600,
      }}
    >
      Ads247.Live
    </h2>
  );
};

export default Logo;
